import React, { useEffect, useRef } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Chip,
} from "@mui/material";
import { motion } from "framer-motion";
import { gsap } from "gsap";
import { arrowele, bobele, Homeimages, triangle } from "../../assets";
import HourglassTimer from "./HourglassTimer";

const MotionBox = motion(Box);

const HeroSectionLuxury = () => {

  const futureDate = new Date();
futureDate.setDate(futureDate.getDate() + 3);

const formattedDate = futureDate.toLocaleDateString("en-GB", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

  const logoRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    if (logoRef.current) {
      gsap.fromTo(
        logoRef.current,
        { y: -80, opacity: 0, scale: 0.8 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 1.5,
          ease: "power4.out",
        }
      );
    }
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        background:
          //   "linear-gradient(135deg, #050510 0%, #0b0f2a 40%, #000 100%)",
          "linear-gradient(135deg, #000 0%, #000 40%, #000 100%)",
      }}
    >
      {/* TOP LEFT BLOB */}
      <Box
        component="img"
        src={bobele}
        alt="blob"
        sx={{
          position: "absolute",
          top: -120,
          left: -150,
          width: 450,
          opacity: 0.9,
          zIndex: 0,
        }}
      />

      {/* RIGHT BOTTOM BLOB */}
      <Box
        component="img"
        src={triangle}
        alt="blob2"
        sx={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: 500,
          opacity: 0.6,
          //   transform: "rotate(270deg)",
          zIndex: 0,
          //    transform: "scaleX(-1)",
        }}
      />

      {/* GOLD GLOW */}
      <Box
        sx={{
          position: "absolute",
          width: 500,
          height: 500,
          top: "-150px",
          right: "-150px",
          background:
            "radial-gradient(circle, rgba(212,175,55,0.25), transparent 70%)",
          filter: "blur(120px)",
        }}
      />

      {/* LOGO */}
      <Box
        sx={{
          position: "absolute",
          top: 18,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 3,
          mb:4
        }}
      >
        <Box
          component="img"
          ref={logoRef}
          src={Homeimages.rwsignlogo}
          alt="logo"
          sx={{ height: 100 }}
        />
      </Box>

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2,  }}>
        <Grid container spacing={6} alignItems="center" mt={5}>
          {/* LEFT CONTENT */}
          <Grid item xs={12} md={6}>
            <MotionBox
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              sx={{
                position: "relative",
                padding: "60px",
                borderRadius: "28px",
                backdropFilter: "blur(30px)",
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(212,175,55,0.2)",
                boxShadow:
                  "0 40px 80px rgba(0,0,0,0.8), inset 0 0 40px rgba(212,175,55,0.05)",
              }}
            >
              <Chip
                label="🔥 LIMITED SEATS – LIVE MASTERCLASS"
                sx={{
                  background: "#111",
                  color: "white",
                  mb: 3,
                  fontWeight: 600,
                }}
              />

              <Typography
                sx={{
                  color: "#d4af37",
                  fontWeight: 700,
                  letterSpacing: 1,
                  fontSize: 14,
                }}
              >
                FREE LIVE BUSINESS MASTERCLASS
              </Typography>

              <Typography
                variant="h3"
                sx={{
                  fontWeight: 800,
                  mt: 2,
                  lineHeight: 1.2,
                  background:
                    "linear-gradient(90deg, #ffffff 0%, #d4af37 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Build A High-Income Skill &
                Scale To Predictable Income In 2026
              </Typography>

              <Typography
                sx={{
                  mt: 3,
                  color: "#cbd5e1",
                  fontSize: 18,
                }}
              >
                Discover the authority positioning and income scaling system
                used by high-performing professionals.
              </Typography>

              <Button
                variant="contained"
                sx={{
                  mt: 5,
                  background:
                    "linear-gradient(90deg, #0f63a5, #0c4f85)",
                  color: "#fff",
                  px: 6,
                  py: 2,
                  fontWeight: 800,
                  borderRadius: "14px",
                  boxShadow:
                    "0 20px 60px rgba(15,99,165,0.4)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background:
                      "linear-gradient(90deg, #0c4f85, #0f63a5)",
                    transform: "translateY(-4px)",
                    boxShadow:
                      "0 30px 80px rgba(15,99,165,0.6)",
                  },
                }}
              >
                RESERVE MY FREE SEAT
              </Button>

              <Typography
                sx={{
                  mt: 2,
                  fontSize: 13,
                  color: "#94a3b8",
                }}
              >
                5,000+ Professionals Impacted | Practical Framework | No Fluff
              </Typography>
            </MotionBox>
          </Grid>

          {/* RIGHT IMAGE */}
          <Grid item xs={12} md={6}>
            <MotionBox
              initial={{ opacity: 0, x: 60 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
              sx={{ position: "relative", textAlign: "center" }}
            >
              <Box className="event-minimal">
                <p className="mini-tag" >LIVE MASTERCLASS</p>

                <h1 className="premium-title">
                  <span className="highlight">2-Hour</span> Online
                  <br />
                  Workshop
                </h1>

                <div className="line-accent"></div>

                <p className="event-date">{formattedDate}</p>
                <p className="event-time">11:00 AM — 1:00 PM</p>
              </Box>
              {/* <Box
                component="img"
                src="https://dprstorage.b-cdn.net/RW/rw2webinar.png"
                alt="Speaker"
                sx={{
                  width: "100%",
                  maxWidth: "500px",
                  filter:
                    "drop-shadow(0px 30px 80px rgba(0,0,0,0.9))",
                }}
              /> */}
              <HourglassTimer />

              <Box
                component="img"
                src={arrowele}
                alt="arrow"
                sx={{
                  position: "absolute",
                  top: 30,
                  right: -40,
                  width: 140,
                  opacity: 0.9,
                }}
              />
            </MotionBox>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSectionLuxury;